import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { Dashboard } from '@omnea-app/fe-dashboard/Dashboard'
import { SupplierDashboard } from '@omnea-app/fe-supplier-dashboard/SupplierDashboard'

export default function Index() {
  const { user } = useAuthenticatedUser()
  return user.isSupplier ? <SupplierDashboard /> : <Dashboard />
}
